import styled from "styled-components/macro";

export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: center;
  transition: 0.5s;
  grid-column: 2/3;
  @media ${(props) => props.theme.media.leftmenu} {
    grid-column: 1/2;
  }
  & .rooms-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media ${(props) => props.theme.media.phone} {
    & .text-edit {
      display: none;
    }
    & .rooms-filter {
      padding: 8px;
    }

    gap: 0;
    margin-top: 24px;
  }
  & > div > div > h4 {
    font-size: 18px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  width: 100%;
  & > div {
    max-width: 30%;
    width: 100%;
    & > label {
      display: none;
    }
  }


  #moveInDate {
    margin: 0 5px;
    width: min-content;
    div {
      padding-right: 0;
    }
  } 
  #moveOutDate {
    margin: 0 5px;
    width: min-content;
    div {
      padding-right: 0;
    }
  }
  @media ${(props) => props.theme.media.phone} {
    & > div {
      max-width: 100%;
      width: 100%;
      margin-top: 4px
    }
    #moveInDate {
      margin: 0 2px 0 0;
    }
    #moveOutDate {
      margin: 0 0 0 2px;
    }
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const GridContainer = styled.div`
  display: grid;

  #moveInDate {
    grid-area: moveInDate;
  }

  #moveOutDate {
    grid-area: moveOutDate;
  }

  #budget {
    grid-area: budget;
  }

  #whereToGo {
    grid-area: whereToGo;
  }

  grid-template-areas:
    "moveInDate moveOutDate"
    "budget whereToGo";
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  grid-template-rows: repeat(2, auto);
  width: 100%;
  max-width: 540px;

  @media ${(props) => props.theme.media.phone} {
    grid-template-areas:
      "moveInDate"
      "moveOutDate"
      "budget"
      "whereToGo";
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
  }
`;

export const Description = styled.p`
  font-size: 20px;
  line-height: 130%;
  color: ${(props) => props.theme.colors.text};
  margin-top: 8px;

  @media ${(props) => props.theme.media.phone} {
    display: none;
  }
`;

export const DescriptionSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  .filter {
    align-self: flex-end;
    margin-bottom: 1em;
    cursor: pointer;
    color: ${(props) => props.theme.colors.text};
    position: relative;
    min-width: 150px;
    z-index: 1;
    @media ${(props) => props.theme.media.phone} {
      margin: 0;
    }

    .filterList {
      position: absolute;
      background: ${(props) => props.theme.colors.place};
      border: 1px solid ${(props) => props.theme.colors.border};
      border-radius: 4px;
      width: 100%;

      .listItem {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 5px;

        &:hover,
        &.selected {
          background: ${(props) => props.theme.colors.secondary};
        }
      }
    }
  }
`;

export const CardContainer = styled.section`
  display: grid;
  gap: 1rem;
  margin-bottom: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  width: 100%;
`;

export const EmptyRoomsSection = styled.section`
  width: 100%;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.secondary};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 4px;
  padding: 2rem;
  margin-top: 24px;
`;
